var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.25 16.226v.274a3 3 0 0 1-3 3H4.5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h9.75a3 3 0 0 1 3 3v.274l2.834-2.186c.986-.76 2.416-.058 2.416 1.188v10.448c0 1.246-1.43 1.949-2.416 1.188zM4.5 6h9.75a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5H4.5A1.5 1.5 0 0 1 3 16.5v-9A1.5 1.5 0 0 1 4.5 6m12.75 8.331L21 17.224V6.776l-3.75 2.893z",
    clipRule: "evenodd"
  })));
};
export default SvgVideo;